import React, {useContext, useState, useEffect} from 'react';
import "./teacherManagementForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import {DatePicker} from "@material-ui/pickers";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {PAYMENT_STATUS_STUDENT_PAID, PAYMENT_STATUS_PAID, PAYMENT_TYPE_TEACHER_HOUR} from "../../utils/constants";
import Papa from 'papaparse';
import { saveAs } from 'file-saver';

const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    { id: 'name', label: 'Name', minWidth: 170 },
    // {
    //     id: 'icNo',
    //     label: 'IC No.',
    //     minWidth: 170,
    //     align: 'right',
    // },
    {
        id: 'phoneNo',
        label: 'Phone No.',
        minWidth: 140,
        align: 'right',
    },
    {
        id: 'totalSalary',
        label: 'Total salary (RM)',
        minWidth: 140,
        align: 'right',
        format: (value) => {return (value/100).toFixed(2);} ,
    },
    {
        id: 'status',
        label: 'Status',
        minWidth: 130,
        align: 'right',
    },
    {
        id: 'month',
        label: 'Month',
        minWidth: 120,
        align: 'right',
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const TeacherSalaryList = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { setFormData } = actions.formActions; // export setFormData function
    const { teachersSalary, teacherSalaryDetail, teacherPaymentDetailDialogVisible } = state.paymentStates;
    const { getTeachersSalary, showTeacherPaymentDetailDialog, submitTeacherPaymentDetail, getSingleTeacherSalary } = actions.paymentActions;
    const [hourlyRateSalary, setHourlyRateSalary] = useState(0);
    const [selectedDate, handleDateChange] = useState(new Date());
    const [salaryErrorText, setSalaryErrorText] = useState("");

    useEffect(() => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        getTeachersSalary(month);
    }, []);

    const [teacherName, setTeacherName] = React.useState(null);

    const handleTeacherNameChange = (event) => {
        setTeacherName(event.target.value);
    };

    const onPayNowClick = (nric) => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        showTeacherPaymentDetailDialog(true);
        getSingleTeacherSalary(nric, month);
    };

    const handleSearchButton = () => {
        const month = moment(selectedDate).format('MM-YYYY') ;
        getTeachersSalary(month);
    };

    const handleClose = () => {
        showTeacherPaymentDetailDialog(false);
    };

    const handlePayNow = () => {
        if (teacherSalaryDetail.paymentType === PAYMENT_TYPE_TEACHER_HOUR && (hourlyRateSalary <= 0)){
            setSalaryErrorText("Please enter your salary");
            return;
        } else if (teacherSalaryDetail.paymentType === PAYMENT_TYPE_TEACHER_HOUR && isNaN(parseFloat(hourlyRateSalary))){
            setSalaryErrorText("Please enter valid number");
            return;
        } else {
            setSalaryErrorText("");
        }

        const month = moment(selectedDate).format('MM-YYYY') ;
        if (teacherSalaryDetail.paymentType === PAYMENT_TYPE_TEACHER_HOUR){
            submitTeacherPaymentDetail({
                id: teacherSalaryDetail.id,
                month,
                fee: hourlyRateSalary * teacherSalaryDetail.paymentRate * 100
            });
        } else {
            submitTeacherPaymentDetail({
                id: teacherSalaryDetail.id,
                month
            });
        }

        showTeacherPaymentDetailDialog(false);
    };

    const handleDownloadNow = () => {
        let totalFee = 0;
        const salaryDetails = teacherSalaryDetail.salaryDetails;
        if (teacherSalaryDetail.salaryDetails==null) return;

        const details = [];
        for (let i = 0; i < salaryDetails.length; i++){
            totalFee += salaryDetails[i].fee;
        }
        for (let i = 0; i < salaryDetails.length; i++){
            const salaryDetail = salaryDetails[i];
            const column = [];
            column.push(salaryDetail.studentName);
            column.push(salaryDetail.programLvl);
            column.push(salaryDetail.subjectName);
            column.push(salaryDetail.paymentDate);
            column.push(salaryDetail.transactionDate);
            column.push((salaryDetail.fee/100).toFixed(2));

            // column.studentName = salaryDetail.studentName;
            // column.programLvl = salaryDetail.programLvl;
            // column.subjectName = salaryDetail.subjectName;
            // column.paymentDate = salaryDetail.paymentDate;
            // column.transactionDate = salaryDetail.transactionDate;
            // column.fee = (salaryDetail.fee/100).toFixed(2);
            details.push(column);
        }
        const totalFeeColumn = [];
        totalFeeColumn.push("");
        totalFeeColumn.push("");
        totalFeeColumn.push("");
        totalFeeColumn.push("");
        totalFeeColumn.push("Total Fee");
        totalFeeColumn.push((totalFee/100).toFixed(2));
        details.push(totalFeeColumn);

        const calculatedFeeColumn = [];
        calculatedFeeColumn.push("");
        calculatedFeeColumn.push("");
        calculatedFeeColumn.push("");
        calculatedFeeColumn.push("");
        calculatedFeeColumn.push(`Teacher Salary (${teacherSalaryDetail.paymentRate})`);
        calculatedFeeColumn.push((totalFee/100 * teacherSalaryDetail.paymentRate).toFixed(2));
        details.push(calculatedFeeColumn);

        var csv = Papa.unparse({
            "fields": ["Student Name", "Program Level", "Subject Name", "Payment Month", "Transaction Date", "Fee"],
            "data": details
        });

        const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(csvData, teacherSalaryDetail.name);
    }

    const renderTeacherDetails = () => {
        let totalFee = 0;
        const salaryDetails = teacherSalaryDetail.salaryDetails;
        if (teacherSalaryDetail.salaryDetails==null) return;
        for (let i = 0; i < salaryDetails.length; i++){
            totalFee += salaryDetails[i].fee;
        }

        //render hourly rate
        const pendingHourlyRate = (
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">No. of hours</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Payment Rate</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableCell>
                            <TextField
                                margin="dense"
                                value={hourlyRateSalary}
                                helperText={salaryErrorText}
                                onChange={e => setHourlyRateSalary(e.target.value)}
                                error={salaryErrorText.length > 0? true : false}
                            />
                        </TableCell>
                        <TableCell><span>{`RM ${teacherSalaryDetail.paymentRate}`}</span></TableCell>

                        <TableRow>
                            <TableCell colSpan={1}><b>Total (RM)</b></TableCell>
                            <TableCell align="left"><b>{(hourlyRateSalary * teacherSalaryDetail.paymentRate).toFixed(2)}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );

        const paidHourlyRate = (
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="center">Total (RM)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left"><b>{teacherSalaryDetail.salaryDetails.length>0 && teacherSalaryDetail.salaryDetails[0].fee? (teacherSalaryDetail.salaryDetails[0].fee/100).toFixed(2) : 0}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );

        const hourlyRate = (
            <div>
                {teacherSalaryDetail.paymentStatus === PAYMENT_STATUS_PAID ? paidHourlyRate: pendingHourlyRate }
            </div>
        )

        const  salaryAnalysis  = (
            <TableContainer component={Paper} style={{marginTop: "10px"}}>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Student Name</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Program Level</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Subject Name</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Payment Month</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="left">Transaction Date</TableCell>
                            <TableCell
                                style={{ background: "#3f51b5", color: "white" }}
                                align="right">Fee</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {salaryDetails.map((row) => (
                            <TableRow key={row.subscriptionId}>
                                <TableCell>{row.studentName}</TableCell>
                                <TableCell>{row.programLvl}</TableCell>
                                <TableCell>{row.subjectName}</TableCell>
                                <TableCell>{row.paymentDate}</TableCell>
                                <TableCell>{row.transactionDate}</TableCell>
                                <TableCell align="right">{(row.fee/100).toFixed(2)}</TableCell>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell><b>Payment rate</b></TableCell>
                            <TableCell align="right"><b>{Math.round(teacherSalaryDetail.paymentRate* 1000)/1000}</b></TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell rowSpan={1} />
                            <TableCell rowSpan={1} />
                            <TableCell rowSpan={1} />
                            <TableCell rowSpan={1} />
                            <TableCell colSpan={1}><b>Total</b></TableCell>
                            <TableCell align="right"><b>{(totalFee/100 * teacherSalaryDetail.paymentRate).toFixed(2)}</b></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )

        return (
            <div>
                <TextField margin="dense" label="Name"
                           value={teacherSalaryDetail.name} fullWidth disabled
                />
                <TextField margin="dense" label="Nric No."
                           value={teacherSalaryDetail.icNo} fullWidth disabled
                />
                <TextField margin="dense" label="Phone No."
                           value={teacherSalaryDetail.phoneNo} fullWidth disabled
                />
                {teacherSalaryDetail.paymentType === PAYMENT_TYPE_TEACHER_HOUR? hourlyRate : salaryAnalysis}
            </div>
        )
    };


    return (
        <div className="student-management-container">
            <h1 className="header">Teachers Salary</h1>
            <div className="paperContainer">
                <DatePicker
                    className="date-picker"
                    views={["year", "month"]}
                    label="Payment Date"
                    value={selectedDate}
                    onChange={handleDateChange}
                />
                <TextField className="text-field" label="Teacher name" onChange={handleTeacherNameChange}/>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

            </div>

            <div className="table-container">
                {teachersSalary && <FixedHeaderTable columns={columns} rows={teachersSalary} buttonContent="View Details" buttonAction={onPayNowClick}/>}
            </div>

            <Dialog open={teacherPaymentDetailDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title">Payment Details</DialogTitle>
                <DialogContent>
                    {renderTeacherDetails()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDownloadNow} color="primary">
                        Download
                    </Button>
                    <Button onClick={handlePayNow} color="primary" disabled={teacherSalaryDetail.paymentStatus === PAYMENT_STATUS_PAID}>
                        Pay now
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withRouter(TeacherSalaryList)
